import { BADFAMILY } from "dns";
import { StringHelper } from "./StringHelper";

export class ObjectCompareResult {
    public Same: boolean = false;
    public DifferentField: string = null;
}
export class ObjectHelper {
    static Empty(): Object {
        return {};
    }

    static IsNull(obj: any): boolean {
        return obj === null;
    }

    static IsNotNull(obj: any): boolean {
        return obj !== null;
    }

    static IsUndefined(obj: any): boolean {
        return typeof obj === 'undefined';
    }

    static IsNotUndefined(obj: any): boolean {
        return typeof obj !== 'undefined';
    }

    static IsNullOrUndefined(obj: any): boolean {
        return this.IsNull(obj) || this.IsUndefined(obj);
    }

    static IsNullOrUndefinedOrEmptyOrStringEmpty(obj: any): boolean {
        //console.log(obj == 'undefined' || obj == undefined || obj == null || (obj.length <= 0 ? true : false) || (Object.keys(obj).length === 0 && obj.constructor === Object))
        return obj == 'undefined' || obj == undefined || obj == null || (obj.length <= 0 ? true : false) || (Object.keys(obj).length === 0 && obj.constructor === Object);
    }

    static ArrayIs(item: any): boolean {
        return (this.IsNotNullAndUndefinedAndEmpty(item) && Array.isArray(item) && item.length > 0)
    }

    static ArrayEmpty(item: any): boolean {
        return (this.IsNotNullAndUndefinedAndEmpty(item) && Array.isArray(item) && item.length == 0)
    }

    static ObjectIs(item: any): boolean {
        return this.IsNotNullAndUndefinedAndEmpty(item);
    }

    static IsPositiveNumber(item: any): boolean {
        return this.ObjectIs(item) && item > 0;
    }
    static GetFirstItemOfArrayByProperty(array: Array<any>, propertyName: string, value: any): any {
        if (this.ArrayIs(array)) {
            let filteredData = array.filter((item) => item.hasOwnProperty(propertyName) && item[propertyName] == value);
            if (this.ArrayIs(filteredData)) {
                return JSON.parse(JSON.stringify(filteredData[0]));
            }
        }
        return null;
    }

    static GetFirstItemPropertyOfArrayByProperty(array: Array<any>, propertyName: string, value: any, propertyNameResult: string): any {
        if (this.ArrayIs(array)) {
            let filteredData = array.filter((item) => item.hasOwnProperty(propertyName) && item[propertyName] == value);
            if (this.ArrayIs(filteredData) && this.ObjectIs(filteredData[0]) && filteredData[0].hasOwnProperty(propertyNameResult)) {
                return filteredData[0][propertyNameResult];
            }
        }
        return null;
    }

    static GetFirstItemPropertyOfArrayByPropertyWithDefaultValue(array: Array<any>, propertyName: string, value: any, propertyNameResult: string, defValue: any): any {
        if (this.ArrayIs(array)) {
            let filteredData = array.filter((item) => item.hasOwnProperty(propertyName) && item[propertyName] == value);
            if (this.ArrayIs(filteredData) && this.ObjectIs(filteredData[0]) && filteredData[0].hasOwnProperty(propertyNameResult)) {
                return filteredData[0][propertyNameResult];
            }
        }
        return defValue;
    }

    static IsNotNullAndUndefined(obj: any): boolean {
        return this.IsNotNull(obj) && this.IsNotUndefined(obj);
    }

    static IsNotNullAndUndefinedAndEmpty(obj: any): boolean {
        return this.IsNotNull(obj) && this.IsNotUndefined(obj) && obj != this.Empty();
    }

    static Compare(obj1: Object, obj2: Object, ignorePropertyNames: Array<string>, logEnabled: boolean, compareRightObject: boolean = true): ObjectCompareResult {
        let result: ObjectCompareResult = new ObjectCompareResult();

        let x = JSON.parse(JSON.stringify(this.IsNullOrUndefined(obj1) ? null : obj1));
        let y = JSON.parse(JSON.stringify(this.IsNullOrUndefined(obj2) ? null : obj2));

        // If both x and y are null or undefined and exactly the same
        if (x === y) {
            result.Same = true;
            return result;
        }

        // If they are not strictly equal, they both need to be Objects
        if (!(x instanceof Object) || !(y instanceof Object)) {
            //console.log('false1');
            if (logEnabled) {
                //console.log('ObjectHelper.Compare False - both need to be Objects');
            }
            result.Same = false;
            return result;
        }

        // They must have the exact same prototype chain, the closest we can do is test the constructor.
        if (x.constructor !== y.constructor) {
            //console.log('false2');
            if (logEnabled) {
                //console.log('ObjectHelper.Compare - They must have the exact same prototype chain, the closest we can do is test the constructor.');
            }
            result.Same = false;
            return result;
        }

        for (var p in x) {
            // Inherited properties were tested using x.constructor === y.constructor
            if (!p.endsWith('_Caption') && x.hasOwnProperty(p) && ignorePropertyNames.indexOf(p) == -1) {
                //console.log(p);

                if ((Object.prototype.toString.call(x[p]) === '[object Array]') && (x[p].length == 0)) {
                    //console.log('null1');
                    x[p] = null;
                }
                if ((Object.prototype.toString.call(y[p]) === '[object Array]') && (y[p].length == 0)) {
                    //console.log('null2');
                    y[p] = null;
                }

                // Allows comparing x[ p ] and y[ p ] when set to undefined
                if (!y.hasOwnProperty(p) && this.IsNotNullAndUndefined(x[p])) {
                    //console.log('false3', x[p], y[p]);
                    if (logEnabled) {
                        console.log('ObjectHelper.Compare False - property ' + p + ' is null.\nOrg=' + JSON.stringify(y[p]) + '\nNew=' + JSON.stringify(x[p]));
                    }
                    result.DifferentField = p;
                    result.Same = false;
                    return result;
                }

                // If they have the same strict value or identity then they are equal
                if (x[p] == y[p] || x[p] === null && y[p] === '' || x[p] === '' && y[p] === null) {
                    continue;
                }

                // Numbers, Strings, Functions, Booleans must be strictly equal
                if (typeof (x[p]) !== "object") {
                    //console.log('false4', x[p], y[p]);
                    if (logEnabled) {
                        //console.log('ObjectHelper.Compare False - property ' + p + ' Numbers, Strings, Functions, Booleans must be strictly equal.\nOrg=' + JSON.stringify(y[p]) + '\nNew=' + JSON.stringify(x[p]));
                    }
                    result.DifferentField = p;
                    result.Same = false;
                    return result;
                }

                // Objects and Arrays must be tested recursively
                if (!this.Compare(x[p], y[p], ignorePropertyNames, logEnabled).Same) {
                    //console.log('false5');
                    if (logEnabled) {
                        //console.log('ObjectHelper.Compare False - property ' + p + ' Objects and Arrays tested recursively.\nOrg=' + JSON.stringify(y[p]) + '\nNew=' + JSON.stringify(x[p]));
                    }
                    result.DifferentField = p;
                    result.Same = false;
                    return result;
                }
            }
            else {
                //console.log('Ignore ' + p);
            }
        }

        if (compareRightObject) {
            for (p in y) {
                // allows x[ p ] to be set to undefined
                if (!p.endsWith('_Caption') && y.hasOwnProperty(p) && !x.hasOwnProperty(p)) {
                    //console.log('false6');
                    if (logEnabled) {
                        //console.log('ObjectHelper.Compare False - property ' + p + ' not in Org.\nOrg=' + JSON.stringify(x[p]) + '\n;New=' + JSON.stringify(y[p]));
                    }
                    result.DifferentField = p;
                    result.Same = false;
                    return result;
                }
            }
        }
        result.Same = true;
        return result;
    };

    static GetObjectKeys(obj: Object): Array<string> {
        if (obj && typeof obj === 'object') {
            return Object.keys(obj);
        }
        return [];
    }

    static HasObjectNullProperties(obj1: Object): boolean {
        let x = JSON.parse(JSON.stringify(this.IsNullOrUndefined(obj1) ? null : obj1));
        if (this.IsNullOrUndefined(x)) {
            return true;
        }

        let result: boolean = true;
        for (var p in x) {
            if (!p.endsWith('_Caption') && x.hasOwnProperty(p)) {
                //console.log(p, result, x[p], this.IsNullOrUndefinedOrEmptyOrStringEmpty(x[p]))
                result = result && (this.IsNullOrUndefinedOrEmptyOrStringEmpty(x[p]) || p.endsWith('_BasicState') && x[p] == 0 || p.endsWith('_Operator'));
            }
        }
        return result;
    };

    static ArrayIndexByProperty(array: Array<any>, attr: string, value: any): number {
        for (var i = 0; i < array.length; i += 1) {
            if (array[i][attr] === value) {
                return i;
            }
        }
        return -1;
    }

    //static ArrayFindByProperty(array: Array<any>, attr: string, value: any): any {
    //    for(var i = 0; i < array.length; i += 1) {
    //        if(array[i][attr] === value) {
    //            return array[i];
    //        }
    //    }
    //    return null;
    //}

    static MergeProperty(obj1: Object, obj2: Object, propertyName: string) {

        let x = JSON.parse(JSON.stringify(obj1));
        let y = JSON.parse(JSON.stringify(obj2));

        // If both x and y are null or undefined and exactly the same
        if (x === y) {
            return x;
        }

        // If they are not strictly equal, they both need to be Objects
        if (!(x instanceof Object) || !(y instanceof Object)) {
            return x;
        }

        // They must have the exact same prototype chain, the closest we can do is
        // test the constructor.
        if (x.constructor !== y.constructor) {
            return x;
        }

        for (var p in x) {

            // Inherited properties were tested using x.constructor === y.constructor
            if (x.hasOwnProperty(p)) {

                // Allows comparing x[ p ] and y[ p ] when set to undefined
                if (!y.hasOwnProperty(p) && this.IsNotNullAndUndefined(x[p])) {
                    return x;
                }

                // If they have the same strict value or identity then they are equal
                if (x[p] == y[p]) {
                    continue;
                }

                // Numbers, Strings, Functions, Booleans must be strictly equal
                if (typeof (x[p]) !== "object") {
                    return x;
                }

                x[p] = this.MergeProperty(x[p], y[p], propertyName);
            }
        }

        for (p in y) {
            if (p != propertyName) {
                continue;
            }

            // allows x[ p ] to be set to undefined
            if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) {
                x[p] = y[p];
            }
        }
        return x;
    };

    static CompareArraysOfNumbers(arr1: Array<number>, arr2: Array<number>) {
        if(this.IsNullOrUndefined(arr1)){
            arr1 = [];
        }
        if(this.IsNullOrUndefined(arr2)){
            arr2 = [];
        }
        arr1.sort()
        arr2.sort()
        return arr1 + "" == arr2 + "";
    }
    
}